import {
 useState
} from 'react';
import {
 Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from 'shared/components/ui/dialog';
import {
 Button
} from 'shared/components/ui/button';
import {
 JSONSchemaBuilder
} from './JSONSchemaBuilder';

interface JSONSchemaBuilderDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    initialSchema?: string;
    onSave: (schema: string) => void;
    title?: string;
}

export function JSONSchemaBuilderDialog({
    open,
    onOpenChange,
    initialSchema,
    onSave,
    title = 'Schema Builder',
}: JSONSchemaBuilderDialogProps) {
    const [currentSchema, setCurrentSchema] = useState<string>(initialSchema || '');

    const handleSave = () => {
        onSave(currentSchema);
        onOpenChange(false);
    };

    const handleCancel = () => {
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-6xl h-[80vh] flex flex-col">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>

                <div className="flex-1 overflow-hidden">
                    <JSONSchemaBuilder
                        initialSchema={initialSchema}
                        onChange={setCurrentSchema}
                        title="Build Your Schema"
                    />
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button onClick={handleSave}>Apply Schema</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
